import React from 'react';
import { s } from '../styles';
import { IconShield, IconSpark } from '../icons';

// Screen 9 — Squeeze ATTENTION + GOOD TO KNOW notes. Final teaching
// pause before the Begin CTA launches the squeeze tryout RingPlayer.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <div className="screen-enter-child" style={s.noteCard}>
        <div style={s.noteRow}>
          <div style={s.noteIconDisc}><IconShield /></div>
          <span style={s.noteChip}>{t('fl_squeeze_attention_label')}</span>
        </div>
        <h2 style={s.noteTitle}>{t('fl_squeeze_attention_title')}</h2>
        <p style={s.noteBody}>{t('fl_squeeze_attention_body')}</p>
      </div>
      <div className="screen-enter-child" style={{ ...s.noteCard, ...s.noteCardWarm }}>
        <div style={s.noteRow}>
          <div style={{ ...s.noteIconDisc, ...s.noteIconDiscWarm }}><IconSpark /></div>
          <span style={{ ...s.noteChip, ...s.noteChipWarm }}>{t('fl_squeeze_goodtoknow_label')}</span>
        </div>
        <h2 style={s.noteTitle}>{t('fl_squeeze_goodtoknow_title')}</h2>
        <p style={s.noteBody}>{t('fl_squeeze_goodtoknow_body')}</p>
      </div>
    </div>
  );
}

// Begin CTA launches the in-overlay squeeze tryout (RingPlayer). The
// orchestrator wires onBeginTryout to setShowTryout(true).
export function Footer({ t, onBeginTryout }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onBeginTryout}>
      {t('fl_squeeze_cta')}
    </button>
  );
}
